import { render, staticRenderFns } from "./DashBoard.vue?vue&type=template&id=be5cfd0c&scoped=true&"
import script from "./DashBoard.vue?vue&type=script&lang=js&"
export * from "./DashBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5cfd0c",
  null
  
)

export default component.exports